



















import mixins from 'vue-typed-mixins'
import I18N from '@/components/I18N.ts'
import axios from 'axios'

interface Data {
  sources: Source[]
  working: boolean
}

export default mixins(I18N).extend({
  components: {
  },
  data (): Data {
    return {
      sources: [],
      working: false
    }
  },
  mounted (): void {
    this.$store.dispatch('setTitle', { key: 'Sources' })

    this.working = true
    axios.get(`${process.env.VUE_APP_API_URL}/sources`)
      .then(response => {
        this.sources = response.data
      })
      .catch(error => {
        this.$store.dispatch('addError', error)
      })
      .then(() => {
        this.working = false
      })
  }
})
